import React, { useState, useEffect, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import styled from 'styled-components';
import { COLUMN_TYPES } from 'constants';

const GridListContainer = styled.div`
  position: relative;
  height: calc(100vh - ${props => props.offsetTop}px);
  overflow: auto;
  > div {
    height: auto !important;
  }
`;

export const GridList = React.forwardRef(
  (
    {
      hideHeader,
      rows,
      columnDefs,
      defaultColDef,
      rowSelection,
      onCellClicked,
    },
    gridRef,
  ) => {
    const containerRef = useRef();
    const [listOffsetTop, setListOffsetTop] = useState(0);

    useEffect(() => {
      // need to calculate table height depends on different size of screen
      setListOffsetTop(containerRef.current.offsetTop);
    }, []);

    return (
      <GridListContainer
        ref={containerRef}
        offsetTop={listOffsetTop}
        className={`ag-theme-material ag-list ${
          hideHeader && 'ag-hidden-header'
        }`}>
        <AgGridReact
          headerHeight={hideHeader && 0}
          ref={gridRef}
          rowData={rows}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          rowBuffer={0}
          rowSelection={rowSelection}
          cacheBlockSize={100}
          cacheOverflowSize={2}
          maxConcurrentDatasourceRequests={1}
          infiniteInitialRowCount={1000}
          maxBlocksInCache={10}
          onCellClicked={onCellClicked}
          columnTypes={COLUMN_TYPES}
          domLayout="autoHeight"
          suppressRowTransform
        />
      </GridListContainer>
    );
  },
);

GridList.defaultProps = {
  hideHeader: false,
  onCellClicked: () => {},
  defaultColDef: {
    resizable: true,
    flex: 1,
  },
};
